module.exports = __webpack_public_path__ + "img/cp_logo.8540d3bd.png";